var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:['gp-payment-element', {'inactive': _setup.incactive}],attrs:{"id":"payment-element"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }